module.exports = __webpack_public_path__ + "img/shape-metal_az_mobile@2x.82d5675a.png";